// x is the number to check if between the min and max
export function isBetween(x, min, max) {
  return x >= min && x <= max;
}
